// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2MocK","total":"Cart_total__q7HLl","actions":"Cart_actions__3THUW","button--alt":"Cart_button--alt__1-ORp","button":"Cart_button__2XFLV"};